(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amd-campaign-films"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-amd-campaign]';
    const filmSelector = '[data-amd-campaign-film]';
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const states = new Map();
    const allowsAutomaticMotion = () => !motionPreference.matches && !connection?.saveData;
    const rootsWithin = (root) => {
      const roots = Array.from(root.querySelectorAll(rootSelector));
      if (root instanceof Element && root.matches(rootSelector)) roots.unshift(root);
      return roots;
    };
    const hydrateFilm = (film) => {
      const source = film.querySelector('[data-amd-campaign-src]');
      if (!source || source.src) return;
      source.src = source.dataset.amdCampaignSrc;
      film.preload = 'metadata';
      film.load();
    };
    const pauseFilm = (film, reset = false) => {
      film.pause();
      if (!reset) return;
      try {
        film.currentTime = 0;
      } catch (_error) {
        return;
      }
    };
    const updateButton = (film) => {
      const button = film.closest('.amd-campaign-film')?.querySelector('[data-amd-campaign-motion]');
      if (!button) return;
      const playing = !film.paused && !film.ended;
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      const icon = button.querySelector('[data-amd-campaign-motion-icon]');
      if (icon) icon.textContent = playing ? 'Ⅱ' : '▶';
      const label = button.querySelector('[data-amd-campaign-motion-label]');
      if (label) label.textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
    };
    const playFilm = (film) => {
      hydrateFilm(film);
      if (!film.paused) return updateButton(film);
      film.play().then(() => updateButton(film)).catch(() => updateButton(film));
    };
    const candidateFilm = (state) => {
      const activeRatio = state.ratios.get(state.active) || 0;
      const activeMotionState = state.active?.dataset.amdMotionState;
      const activeWasManuallySelected = activeMotionState === 'playing' || activeMotionState === 'paused';
      if (activeWasManuallySelected && activeRatio >= .12) return state.active;
      let candidate = null;
      let bestRatio = 0;
      state.ratios.forEach((ratio, film) => {
        if (ratio > bestRatio) {
          candidate = film;
          bestRatio = ratio;
        }
      });
      if (bestRatio < .12) return null;
      return candidate;
    };
    const syncState = (state) => {
      if (!state.inViewport || document.hidden) {
        state.films.forEach((film) => {
          pauseFilm(film, !state.inViewport);
          updateButton(film);
        });
        return;
      }
      const candidate = candidateFilm(state);
      if (candidate) state.active = candidate;
      state.films.forEach((film) => {
        const manuallyStarted = film.dataset.amdMotionState === 'playing';
        const shouldPlay = film === candidate && state.near && (manuallyStarted || allowsAutomaticMotion() && film.dataset.amdMotionState !== 'paused');
        if (shouldPlay) playFilm(film);
        else pauseFilm(film);
        updateButton(film);
      });
    };
    const initialize = (root) => {
      if (states.has(root)) return;
      const films = Array.from(root.querySelectorAll(filmSelector));
      const state = { films, ratios: new Map(), active: films[0], near: false, inViewport: false, proximityObserver: null, viewportObserver: null, filmObserver: null };
      states.set(root, state);
      films.forEach((film) => {
        state.ratios.set(film, 0);
        film.addEventListener('play', () => {
          state.active = film;
          state.films.forEach((otherFilm) => {
            if (otherFilm !== film) pauseFilm(otherFilm);
          });
          state.films.forEach(updateButton);
        });
        film.addEventListener('pause', () => updateButton(film));
        const button = film.closest('.amd-campaign-film')?.querySelector('[data-amd-campaign-motion]');
        button?.addEventListener('click', () => {
          if (film.paused) {
            film.dataset.amdMotionState = 'playing';
            state.active = film;
            state.films.forEach((otherFilm) => {
              if (otherFilm !== film) pauseFilm(otherFilm);
            });
            playFilm(film);
          } else {
            film.dataset.amdMotionState = 'paused';
            pauseFilm(film);
          }
        });
      });
      if ('IntersectionObserver' in window) {
        state.proximityObserver = new IntersectionObserver(([entry]) => {
          state.near = entry.isIntersecting;
          if (state.near) hydrateFilm(state.active || state.films[0]);
          syncState(state);
        }, { rootMargin: '320px 0px', threshold: 0 });
        state.proximityObserver.observe(root);
        state.viewportObserver = new IntersectionObserver(([entry]) => {
          state.inViewport = entry.isIntersecting;
          syncState(state);
        }, { threshold: .01 });
        state.viewportObserver.observe(root);
        state.filmObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const film = entry.target.querySelector(filmSelector);
            if (film) state.ratios.set(film, entry.isIntersecting ? entry.intersectionRatio : 0);
          });
          syncState(state);
        }, { threshold: [0, .12, .3, .5, .75, 1] });
        films.forEach((film) => {
          const card = film.closest('.amd-campaign-film');
          if (card) state.filmObserver.observe(card);
        });
      } else {
        state.near = true;
        state.inViewport = true;
        if (films[0]) state.ratios.set(films[0], 1);
        syncState(state);
        films.forEach(updateButton);
      }
    };
    const destroy = (root) => {
      const state = states.get(root);
      if (!state) return;
      state.proximityObserver?.disconnect();
      state.viewportObserver?.disconnect();
      state.filmObserver?.disconnect();
      state.films.forEach((film) => pauseFilm(film, true));
      states.delete(root);
    };
    const boot = (root) => rootsWithin(root).forEach(initialize);
    const syncAll = () => queueMicrotask(() => states.forEach(syncState));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('shopify:section:unload', (event) => rootsWithin(event.target).forEach(destroy));
    document.addEventListener('visibilitychange', syncAll);
    motionPreference.addEventListener('change', syncAll);
    connection?.addEventListener?.('change', syncAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amd-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const states = new Map();
    const allowsAutomaticMotion = () => !motionPreference.matches && !connection?.saveData;
    const rootsWithin = (root) => {
      const roots = Array.from(root.querySelectorAll('[data-amd-world-hero]'));
      if (root instanceof Element && root.matches('[data-amd-world-hero]')) roots.unshift(root);
      return roots;
    };
    const hydrateFilm = (film) => {
      if (!film) return;
      let changed = false;
      film.querySelectorAll('[data-amd-hero-src]').forEach((source) => {
        if (source.src) return;
        source.src = source.dataset.amdHeroSrc;
        changed = true;
      });
      film.preload = 'metadata';
      if (changed) film.load();
    };
    const pauseFilm = (film, reset = false) => {
      if (!film) return;
      film.pause();
      if (!reset) return;
      try {
        film.currentTime = 0;
      } catch (_error) {
        return;
      }
    };
    const activeFilm = (root) => root.querySelector(`[data-amd-world-film="${root.dataset.amdWorld}"]`);
    const motionFilm = (root) => {
      const film = activeFilm(root);
      if (film?.dataset.amdFailed !== 'true') return film;
      return root.querySelector('.amd-hero__fallback-video');
    };
    const wantsMotion = (root) => {
      const state = states.get(root);
      if (!state?.visible || document.hidden || root.dataset.amdMotionState === 'paused') return false;
      return root.dataset.amdMotionState === 'playing' || allowsAutomaticMotion();
    };
    const updateMotionButton = (root) => {
      const button = root.querySelector('[data-amd-motion-toggle]');
      const film = motionFilm(root);
      if (!button) return;
      button.disabled = !film;
      if (!film) return;
      const playing = !film.paused && !film.ended;
      button.setAttribute('aria-pressed', String(playing));
      const label = button.querySelector('[data-amd-motion-label]');
      if (label) label.textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
    };
    const playFilm = (root, film) => {
      hydrateFilm(film);
      if (!film.paused) return updateMotionButton(root);
      film.play().then(() => updateMotionButton(root)).catch(() => updateMotionButton(root));
    };
    const stopAll = (root, reset = false) => {
      root.querySelectorAll('[data-amd-world-film], .amd-hero__fallback-video').forEach((film) => pauseFilm(film, reset));
      updateMotionButton(root);
    };
    const syncFallback = (root) => {
      const film = activeFilm(root);
      const failed = film?.dataset.amdFailed === 'true';
      root.dataset.amdFallback = String(failed);
      const fallbackFilm = root.querySelector('.amd-hero__fallback-video');
      if (!fallbackFilm) return;
      if (failed && wantsMotion(root)) {
        pauseFilm(film);
        fallbackFilm.preload = 'metadata';
        playFilm(root, fallbackFilm);
      } else {
        pauseFilm(fallbackFilm);
      }
    };
    const setWorld = (root, world) => {
      if (world !== 'water' && world !== 'iron') return;
      const state = states.get(root);
      root.dataset.amdWorld = world;
      root.querySelectorAll('[data-amd-world-target]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.amdWorldTarget === world));
      });
      root.querySelectorAll('[data-amd-world-film]').forEach((film) => {
        const isActive = film.dataset.amdWorldFilm === world;
        film.dataset.amdActive = String(isActive);
        if (!isActive) pauseFilm(film, true);
      });
      const film = activeFilm(root);
      if (!film) return;
      const productLink = root.querySelector('[data-amd-hero-product-link]');
      if (productLink && film.dataset.amdProductUrl) {
        productLink.href = film.dataset.amdProductUrl;
        productLink.setAttribute('aria-label', `${productLink.dataset.amdShopLabel}: ${film.dataset.amdProductTitle}`);
      }
      const fallbackImage = root.querySelector('.amd-hero__fallback-image');
      if (fallbackImage && film.poster) fallbackImage.src = film.poster;
      if (state?.near) hydrateFilm(film);
      else film.preload = 'none';
      syncFallback(root);
      if (wantsMotion(root) && film.dataset.amdFailed !== 'true') {
        playFilm(root, film);
      } else {
        pauseFilm(film);
        updateMotionButton(root);
      }
    };
    const initialize = (root) => {
      if (states.has(root)) return;
      root.dataset.amdWorldReady = 'true';
      const state = { visible: false, near: false, proximityObserver: null, viewportObserver: null };
      states.set(root, state);
      const switchWorld = (world) => {
        const change = () => setWorld(root, world);
        if (document.startViewTransition && !motionPreference.matches) document.startViewTransition(change);
        else change();
      };
      root.querySelectorAll('[data-amd-world-target]').forEach((button) => {
        button.addEventListener('click', () => switchWorld(button.dataset.amdWorldTarget));
      });
      root.querySelectorAll('[data-amd-world-film]').forEach((film) => {
        film.addEventListener('play', () => {
          if (film.dataset.amdActive !== 'true') return pauseFilm(film);
          root.querySelectorAll('[data-amd-world-film]').forEach((otherFilm) => {
            if (otherFilm !== film) pauseFilm(otherFilm);
          });
          pauseFilm(root.querySelector('.amd-hero__fallback-video'));
          updateMotionButton(root);
        });
        film.addEventListener('pause', () => {
          if (film.dataset.amdActive === 'true') updateMotionButton(root);
        });
        film.addEventListener('error', () => {
          film.dataset.amdFailed = 'true';
          if (film.dataset.amdActive === 'true') {
            syncFallback(root);
            updateMotionButton(root);
          }
        });
      });
      const fallbackFilm = root.querySelector('.amd-hero__fallback-video');
      fallbackFilm?.addEventListener('play', () => {
        root.querySelectorAll('[data-amd-world-film]').forEach((film) => pauseFilm(film));
        updateMotionButton(root);
      });
      fallbackFilm?.addEventListener('pause', () => updateMotionButton(root));
      const motionButton = root.querySelector('[data-amd-motion-toggle]');
      motionButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        const film = motionFilm(root);
        if (!film) return;
        if (film.paused) {
          root.dataset.amdMotionState = 'playing';
          film.dataset.amdMotionState = 'playing';
          playFilm(root, film);
        } else {
          root.dataset.amdMotionState = 'paused';
          film.dataset.amdMotionState = 'paused';
          pauseFilm(film);
          updateMotionButton(root);
        }
      });
      if (!allowsAutomaticMotion()) {
        root.querySelectorAll('[data-amd-world-film]').forEach((film) => {
          film.removeAttribute('autoplay');
          film.preload = 'none';
          film.pause();
        });
      }
      setWorld(root, root.dataset.amdWorld || 'water');
      if ('IntersectionObserver' in window) {
        state.proximityObserver = new IntersectionObserver(([entry]) => {
          state.near = entry.isIntersecting;
          if (state.near) hydrateFilm(activeFilm(root));
          setWorld(root, root.dataset.amdWorld || 'water');
        }, { rootMargin: '320px 0px', threshold: 0 });
        state.proximityObserver.observe(root);
        state.viewportObserver = new IntersectionObserver(([entry]) => {
          state.visible = entry.isIntersecting;
          if (state.visible) setWorld(root, root.dataset.amdWorld || 'water');
          else stopAll(root, true);
        }, { threshold: .01 });
        state.viewportObserver.observe(root);
      } else {
        state.near = true;
        state.visible = true;
        setWorld(root, root.dataset.amdWorld || 'water');
      }
    };
    const destroy = (root) => {
      const state = states.get(root);
      if (!state) return;
      state.proximityObserver?.disconnect();
      state.viewportObserver?.disconnect();
      stopAll(root, true);
      states.delete(root);
      delete root.dataset.amdWorldReady;
    };
    const boot = (root) => rootsWithin(root).forEach(initialize);
    const syncMotionPreference = () => {
      queueMicrotask(() => {
        states.forEach((_state, root) => setWorld(root, root.dataset.amdWorld || 'water'));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('shopify:section:unload', (event) => rootsWithin(event.target).forEach(destroy));
    document.addEventListener('visibilitychange', syncMotionPreference);
    motionPreference.addEventListener('change', syncMotionPreference);
    connection?.addEventListener?.('change', syncMotionPreference);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amd-shell"]) return;
  try {
    
  document.documentElement.classList.remove('no-js');

  const amdMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const amdAllowsMotion = () => !amdMotionPreference.matches && !navigator.connection?.saveData;
  const amdWithin = (root, selector) => {
    const nodes = Array.from(root.querySelectorAll(selector));
    if (root instanceof Element && root.matches(selector)) nodes.unshift(root);
    return nodes;
  };

  const amdCutout = (node) => {
    if (!(node instanceof HTMLImageElement) || node.dataset.amdProcessed) return;
    node.dataset.amdProcessed = 'loading';
    const markFailed = () => {
      node.dataset.amdProcessed = 'failed';
      node.classList.add('amd-cutout-fallback');
    };
    const fallbackTimer = window.setTimeout(markFailed, 1800);
    const source = new Image();
    source.crossOrigin = 'anonymous';
    source.onload = () => {
      window.clearTimeout(fallbackTimer);
      node.classList.remove('amd-cutout-fallback');
      node.dataset.amdProcessed = 'loading';
      const scale = Math.min(1, 520 / Math.max(source.naturalWidth, source.naturalHeight));
      const width = Math.max(1, Math.round(source.naturalWidth * scale));
      const height = Math.max(1, Math.round(source.naturalHeight * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      canvas.className = `${node.className} amd-cutout-canvas`;
      if (node.alt) {
        canvas.setAttribute('role', 'img');
        canvas.setAttribute('aria-label', node.alt);
      } else {
        canvas.setAttribute('aria-hidden', 'true');
      }
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) {
        markFailed();
        return;
      }
      try {
        context.drawImage(source, 0, 0, width, height);
        const pixels = context.getImageData(0, 0, width, height);
        const data = pixels.data;
        const corners = [0, (width - 1) * 4, (height - 1) * width * 4, (height * width - 1) * 4];
        const bg = corners.reduce((sum, offset) => [sum[0] + data[offset], sum[1] + data[offset + 1], sum[2] + data[offset + 2]], [0, 0, 0]).map((value) => value / 4);
        const bgLuma = (bg[0] + bg[1] + bg[2]) / 3;
        if (bgLuma < 205) {
          node.dataset.amdProcessed = 'kept';
          return;
        }
        const center = [0, 0, 0];
        let centerSamples = 0;
        for (let y = Math.floor(height * .3); y < Math.ceil(height * .7); y += 1) {
          for (let x = Math.floor(width * .35); x < Math.ceil(width * .65); x += 1) {
            const offset = (y * width + x) * 4;
            center[0] += data[offset];
            center[1] += data[offset + 1];
            center[2] += data[offset + 2];
            centerSamples += 1;
          }
        }
        const centerColor = center.map((value) => value / centerSamples);
        const centerDistance = Math.hypot(
          centerColor[0] - bg[0],
          centerColor[1] - bg[1],
          centerColor[2] - bg[2],
        );
        const colorThreshold = centerDistance > 65 ? 42 : 9;
        const minimumLuma = colorThreshold === 9 ? 220 : Math.max(150, bgLuma - 45);
        const featherStart = colorThreshold === 9 ? 2 : 30;
        const featherWidth = colorThreshold === 9 ? 7 : 12;
        const visited = new Uint8Array(width * height);
        const queue = new Int32Array(width * height);
        let head = 0;
        let tail = 0;
        const enqueue = (index) => {
          if (visited[index]) return;
          const offset = index * 4;
          const red = data[offset];
          const green = data[offset + 1];
          const blue = data[offset + 2];
          const distance = Math.hypot(red - bg[0], green - bg[1], blue - bg[2]);
          if (distance >= colorThreshold || (red + green + blue) / 3 <= minimumLuma) return;
          visited[index] = 1;
          queue[tail++] = index;
        };
        for (let x = 0; x < width; x += 1) { enqueue(x); enqueue((height - 1) * width + x); }
        for (let y = 0; y < height; y += 1) { enqueue(y * width); enqueue(y * width + width - 1); }
        while (head < tail) {
          const index = queue[head++];
          const offset = index * 4;
          const distance = Math.hypot(data[offset] - bg[0], data[offset + 1] - bg[1], data[offset + 2] - bg[2]);
          const edgeAlpha = Math.max(0, Math.min(1, (distance - featherStart) / featherWidth));
          data[offset + 3] = Math.round(data[offset + 3] * edgeAlpha);
          const x = index % width;
          const y = Math.floor(index / width);
          if (x > 0) enqueue(index - 1);
          if (x < width - 1) enqueue(index + 1);
          if (y > 0) enqueue(index - width);
          if (y < height - 1) enqueue(index + width);
        }
        let visiblePixels = 0;
        let minX = width;
        let minY = height;
        let maxX = -1;
        let maxY = -1;
        for (let index = 0; index < width * height; index += 1) {
          if (data[index * 4 + 3] < 32) continue;
          visiblePixels += 1;
          const x = index % width;
          const y = Math.floor(index / width);
          minX = Math.min(minX, x);
          maxX = Math.max(maxX, x);
          minY = Math.min(minY, y);
          maxY = Math.max(maxY, y);
        }
        const visibleRatio = visiblePixels / (width * height);
        const hasProductShape = visibleRatio >= .055
          && visibleRatio <= .68
          && maxX - minX >= width * .18
          && maxY - minY >= height * .18
          && tail >= width * height * .16;
        if (!hasProductShape) {
          node.dataset.amdProcessed = 'failed';
          node.classList.add('amd-cutout-fallback');
          return;
        }
        context.putImageData(pixels, 0, 0);
        node.insertAdjacentElement('afterend', canvas);
        window.requestAnimationFrame(() => {
          canvas.classList.add('amd-cutout-canvas--ready');
          node.dataset.amdProcessed = 'done';
          node.setAttribute('aria-hidden', 'true');
        });
      } catch (error) {
        markFailed();
      }
    };
    source.onerror = () => {
      window.clearTimeout(fallbackTimer);
      markFailed();
    };
    source.src = node.currentSrc || node.src;
  };

  const amdActivateCutouts = (root) => {
    if (!root) return;
    root.querySelectorAll('img[data-amd-cutout]:not([data-amd-processed])').forEach((image) => {
      image.loading = 'eager';
      image.setAttribute('fetchpriority', 'high');
      if (typeof image.decode === 'function') image.decode().catch(() => {});
      amdCutout(image);
    });
  };

  const amdObserveCutouts = (root = document) => {
    const images = root.querySelectorAll('img[data-amd-cutout]:not([data-amd-processed])');
    if (!('IntersectionObserver' in window)) {
      images.forEach(amdCutout);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        const process = () => {
          if (entry.target.loading === 'eager') amdCutout(entry.target);
          else if ('requestIdleCallback' in window) window.requestIdleCallback(() => amdCutout(entry.target), { timeout: 900 });
          else window.setTimeout(() => amdCutout(entry.target), 1);
        };
        if (entry.target.complete) process();
        else entry.target.addEventListener('load', process, { once: true });
      });
    }, { rootMargin: '160px' });
    images.forEach((image) => observer.observe(image));
  };

  const amdBindTilts = (root = document) => {
    root.querySelectorAll('[data-amd-tilt]:not([data-amd-tilt-ready])').forEach((node) => {
      node.dataset.amdTiltReady = 'true';
      node.addEventListener('pointermove', (event) => {
        if (!amdAllowsMotion()) return;
        const box = node.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width - .5) * 2;
        const y = ((event.clientY - box.top) / box.height - .5) * 2;
        node.style.setProperty('--amd-ry', `${x * 4.5}deg`);
        node.style.setProperty('--amd-rx', `${y * -4}deg`);
      });
      node.addEventListener('pointerleave', () => {
        node.style.setProperty('--amd-ry', '0deg');
        node.style.setProperty('--amd-rx', '0deg');
      });
    });
  };

  const amdSetCardFilmState = (card, playing) => {
    if (!card) return;
    card.classList.toggle('is-film-playing', playing);
    const control = card.querySelector('[data-amd-card-film-toggle]');
    if (!control) return;
    const label = playing ? control.dataset.amdPauseLabel : control.dataset.amdPlayLabel;
    control.setAttribute('aria-pressed', String(playing));
    if (label) control.setAttribute('aria-label', label);
    const text = control.querySelector('[data-amd-card-film-control-label]');
    if (text && label) text.textContent = label;
    const playIcon = control.querySelector('[data-amd-card-play-icon]');
    const pauseIcon = control.querySelector('[data-amd-card-pause-icon]');
    if (playIcon) playIcon.toggleAttribute('hidden', playing);
    if (pauseIcon) pauseIcon.toggleAttribute('hidden', !playing);
  };

  const amdStopCardFilm = (film, reset = true) => {
    if (!(film instanceof HTMLVideoElement)) return;
    film.pause();
    if (reset) {
      try {
        film.currentTime = 0;
      } catch (mediaError) {
      }
    }
    amdSetCardFilmState(film.closest('.amd-card'), false);
  };

  const amdStopOtherCardFilms = (activeFilm) => {
    document.querySelectorAll('[data-amd-card-film]').forEach((film) => {
      if (film !== activeFilm) amdStopCardFilm(film);
    });
  };

  const amdPlayCardFilm = (film, explicit = false) => {
    if (!(film instanceof HTMLVideoElement)) return;
    if (!explicit && !amdAllowsMotion()) return;
    const card = film.closest('.amd-card');
    if (!card) return;
    amdStopOtherCardFilms(film);
    film.preload = 'metadata';
    const request = film.play();
    if (!request) {
      amdSetCardFilmState(card, true);
      return;
    }
    request.then(() => amdSetCardFilmState(card, true)).catch(() => amdSetCardFilmState(card, false));
  };

  const amdBindFilms = (root = document) => {
    const hoverPreview = window.matchMedia('(hover: hover) and (pointer: fine)');
    root.querySelectorAll('[data-amd-card-film]:not([data-amd-film-ready])').forEach((film) => {
      film.dataset.amdFilmReady = 'true';
      const card = film.closest('.amd-card');
      if (!card) return;
      const control = card.querySelector('[data-amd-card-film-toggle]');
      if (hoverPreview.matches) {
        card.addEventListener('pointerenter', () => amdPlayCardFilm(film));
        card.addEventListener('pointerleave', () => amdStopCardFilm(film));
      }
      card.querySelector('.amd-card__link')?.addEventListener('focusin', () => amdPlayCardFilm(film));
      card.addEventListener('focusout', (event) => {
        if (!card.contains(event.relatedTarget)) amdStopCardFilm(film);
      });
      control?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (film.paused || !card.classList.contains('is-film-playing')) amdPlayCardFilm(film, true);
        else amdStopCardFilm(film);
      });
      film.addEventListener('play', () => {
        amdStopOtherCardFilms(film);
        amdSetCardFilmState(card, true);
      });
      film.addEventListener('pause', () => amdSetCardFilmState(card, false));
      amdSetCardFilmState(card, !film.paused);
    });
  };

  const amdSelectedOptionValues = (section) => Array.from(section.querySelectorAll('[data-amd-option-value]:checked')).map((input) => input.dataset.optionValueId).join(',');

  const amdPrimeProducts = (root = document) => {
    amdWithin(root, '[data-amd-product-section]').forEach((section) => {
      section.dataset.amdSelection = amdSelectedOptionValues(section);
      const variantInput = section.querySelector('[data-amd-variant-input]');
      const noScriptVariant = section.querySelector('[data-amd-noscript-variant]');
      if (variantInput) variantInput.disabled = false;
      if (noScriptVariant) noScriptVariant.disabled = true;
    });
  };

  const amdSetPurchaseBusy = (section, busy) => {
    const form = section.querySelector('[data-amd-product-form]');
    const selectors = section.querySelector('[data-amd-option-selectors]');
    if (form) form.setAttribute('aria-busy', String(busy));
    if (selectors) {
      selectors.setAttribute('aria-busy', String(busy));
      if (busy) {
        selectors.dataset.amdWasInert = String(selectors.inert);
        selectors.inert = true;
      } else if (selectors.dataset.amdWasInert !== undefined) {
        selectors.inert = selectors.dataset.amdWasInert === 'true';
        delete selectors.dataset.amdWasInert;
      }
    }
    section.querySelectorAll('.shopify-payment-button').forEach((payment) => {
      if (busy) {
        payment.dataset.amdWasInert = String(payment.inert);
        payment.inert = true;
      } else if (payment.dataset.amdWasInert !== undefined) {
        payment.inert = payment.dataset.amdWasInert === 'true';
        delete payment.dataset.amdWasInert;
      }
    });
    section.querySelectorAll('[data-amd-purchase-action], .shopify-payment-button button').forEach((button) => {
      if (busy) {
        button.dataset.amdWasDisabled = String(button.disabled);
        button.disabled = true;
      } else if (button.dataset.amdWasDisabled !== undefined) {
        button.disabled = button.dataset.amdWasDisabled === 'true';
        delete button.dataset.amdWasDisabled;
      }
    });
  };

  let amdCartRestoreFocus;
  const amdCartDrawer = () => document.querySelector('[data-amd-cart-drawer]');
  const amdCartRoot = () => window.Shopify?.routes?.root || amdCartDrawer()?.dataset.rootUrl || '/';
  const amdCartEndpoint = (path) => `${amdCartRoot()}${path}`;
  const amdRestoreCartFocus = () => {
    if (!amdCartRestoreFocus?.isConnected) {
      document.querySelector('[data-amd-cart-toggle]')?.focus();
      amdCartRestoreFocus = undefined;
      return true;
    }
    if (amdCartRestoreFocus.disabled) return false;
    amdCartRestoreFocus.focus();
    amdCartRestoreFocus = undefined;
    return true;
  };
  const amdCartMessage = (drawer, message, error = false) => {
    const status = drawer.querySelector('[data-amd-cart-status]');
    const alert = drawer.querySelector('[data-amd-cart-error]');
    const fallback = drawer.querySelector('[data-amd-cart-fallback]');
    if (status) status.textContent = error ? '' : message;
    if (alert) {
      alert.textContent = error ? message : '';
      alert.hidden = !error;
    }
    if (fallback) fallback.hidden = !error;
  };

  const amdCheckoutBusyState = new WeakMap();
  const amdCartBusy = (drawer, busy) => {
    drawer.setAttribute('aria-busy', String(busy));
    drawer.querySelectorAll('[data-amd-cart-action]').forEach((control) => {
      control.disabled = busy;
    });
    const checkout = drawer.querySelector('[data-amd-cart-checkout]');
    if (!checkout) return;
    if (busy) {
      if (!amdCheckoutBusyState.has(checkout)) {
        amdCheckoutBusyState.set(checkout, {
          inert: checkout.inert,
          ariaDisabled: checkout.getAttribute('aria-disabled'),
          tabindex: checkout.getAttribute('tabindex')
        });
      }
      checkout.inert = true;
      checkout.setAttribute('aria-disabled', 'true');
      checkout.setAttribute('tabindex', '-1');
    } else {
      const previous = amdCheckoutBusyState.get(checkout);
      if (!previous) return;
      checkout.inert = previous.inert;
      if (previous.ariaDisabled === null) checkout.removeAttribute('aria-disabled');
      else checkout.setAttribute('aria-disabled', previous.ariaDisabled);
      if (previous.tabindex === null) checkout.removeAttribute('tabindex');
      else checkout.setAttribute('tabindex', previous.tabindex);
      amdCheckoutBusyState.delete(checkout);
    }
  };

  const amdCartMoney = (drawer, amount, currency) => {
    const activeCurrency = currency || drawer.dataset.currency || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: activeCurrency,
        currencyDisplay: 'narrowSymbol'
      }).format(Number(amount || 0) / 100);
    } catch (formatError) {
      return `${(Number(amount || 0) / 100).toFixed(2)} ${activeCurrency}`;
    }
  };

  const amdCartLink = (path, fallback) => {
    try {
      const url = new URL(path || fallback, window.location.origin);
      return url.origin === window.location.origin ? url.href : fallback;
    } catch (urlError) {
      return fallback;
    }
  };

  const amdCartImage = (source) => {
    if (!source) return '';
    try {
      const url = new URL(source, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (urlError) {
      return '';
    }
  };

  const amdRenderCart = (drawer, cart) => {
    const items = drawer.querySelector('[data-amd-cart-items]');
    const empty = drawer.querySelector('[data-amd-cart-empty]');
    const summary = drawer.querySelector('[data-amd-cart-summary]');
    const checkout = drawer.querySelector('[data-amd-cart-checkout]');
    const subtotal = drawer.querySelector('[data-amd-cart-subtotal]');
    const hasItems = Number(cart.item_count) > 0;
    document.querySelectorAll('[data-amd-cart-count]').forEach((count) => {
      count.textContent = String(cart.item_count || 0);
    });
    if (empty) empty.hidden = hasItems;
    if (summary) summary.hidden = !hasItems;
    if (checkout) {
      checkout.hidden = !hasItems;
      checkout.href = drawer.dataset.checkoutUrl;
    }
    if (subtotal) subtotal.textContent = amdCartMoney(drawer, cart.total_price, cart.currency);
    if (!items) return;
    items.replaceChildren();
    const fragment = document.createDocumentFragment();
    (cart.items || []).forEach((item) => {
      const displayTitleOverrides = {
        'amd-circle-baby-tee': 'AMD Circle Baby Tee — Cream',
        'amd-circle-baby-tee-1': 'AMD Circle Baby Tee',
        'amd-full-zip': 'AMD Full Zip — Core',
        'amd-full-zip-1': 'AMD Full Zip — Tonal',
        'amd-full-zip-2': 'AMD Full Zip — Crest',
        'amd-full-zip-3': 'AMD Full Zip — Graphic',
        'anchor-standard': 'Anchor Standard — Dark',
        'anchor-standard-1': 'Anchor Standard — Light',
        'roses-boxy-tank': 'Roses Boxy Tank — Classic',
        'roses-boxy-tank-1': 'Roses Boxy Tank — Extended',
        'sleeveless-hoodie-amd': 'Sleeveless Hoodie — Brown',
        'sleeveless-hoodie-amd-1': 'Sleeveless Hoodie — Grey'
      };
      const productTitle = displayTitleOverrides[item.handle] || item.product_title || item.title || '';
      const productUrl = amdCartLink(item.url, drawer.dataset.cartUrl);
      const line = document.createElement('article');
      line.className = 'amd-cart-drawer__line';
      line.setAttribute('role', 'listitem');

      const imageLink = document.createElement('a');
      imageLink.className = 'amd-cart-drawer__image';
      imageLink.href = productUrl;
      const imageSource = amdCartImage(item.featured_image?.url || item.image);
      if (imageSource) {
        const image = document.createElement('img');
        image.src = imageSource;
        image.alt = item.featured_image?.alt || productTitle;
        image.loading = 'lazy';
        image.width = 184;
        image.height = 232;
        // Preserve the Shopify cart photo without altering garment pixels.
        imageLink.append(image);
      }

      const detail = document.createElement('div');
      detail.className = 'amd-cart-drawer__detail';
      const title = document.createElement('h3');
      const titleLink = document.createElement('a');
      titleLink.href = productUrl;
      titleLink.textContent = productTitle;
      title.append(titleLink);
      detail.append(title);
      const options = (item.options_with_values || []).filter((option) => option.value && option.value !== 'Default Title');
      if (options.length) {
        const variant = document.createElement('p');
        variant.textContent = options.map((option) => `${option.name}: ${option.value}`).join(' · ');
        detail.append(variant);
      }

      const price = document.createElement('strong');
      price.className = 'amd-cart-drawer__price';
      price.textContent = amdCartMoney(drawer, item.final_line_price, cart.currency);

      const quantity = document.createElement('label');
      quantity.className = 'amd-cart-drawer__quantity';
      const quantityText = document.createElement('span');
      quantityText.textContent = drawer.dataset.quantityLabel;
      const quantityInput = document.createElement('input');
      quantityInput.type = 'number';
      quantityInput.min = '0';
      quantityInput.step = '1';
      quantityInput.value = String(item.quantity);
      quantityInput.defaultValue = String(item.quantity);
      quantityInput.dataset.amdCartAction = 'quantity';
      quantityInput.dataset.lineKey = item.key;
      quantityInput.setAttribute('aria-label', `${drawer.dataset.quantityLabel}: ${productTitle}`);
      quantity.append(quantityText, quantityInput);

      const remove = document.createElement('button');
      remove.className = 'amd-cart-drawer__remove';
      remove.type = 'button';
      remove.textContent = drawer.dataset.removeLabel;
      remove.dataset.amdCartAction = 'remove';
      remove.dataset.lineKey = item.key;
      remove.setAttribute('aria-label', `${drawer.dataset.removeLabel}: ${productTitle}`);
      line.append(imageLink, detail, price, quantity, remove);
      fragment.append(line);
    });
    items.append(fragment);
    amdObserveCutouts(items);
  };

  const amdCartRequest = async (path, options) => {
    const { headers = {}, ...requestOptions } = options || {};
    const response = await fetch(amdCartEndpoint(path), {
      credentials: 'same-origin',
      ...requestOptions,
      headers: { Accept: 'application/json', ...headers }
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || '');
    return data;
  };

  const amdOpenCart = async (trigger, announcement = '') => {
    const drawer = amdCartDrawer();
    if (!drawer || typeof drawer.showModal !== 'function') return false;
    const menuButton = document.querySelector('[data-amd-menu-toggle][aria-expanded="true"]');
    if (menuButton) amdSetMenu(menuButton, false);
    amdCartRestoreFocus = trigger || document.activeElement;
    if (!drawer.open) drawer.showModal();
    document.body.classList.add('amd-cart-open');
    drawer.querySelector('[data-amd-cart-close]')?.focus();
    amdCartMessage(drawer, drawer.dataset.loadingLabel);
    amdCartBusy(drawer, true);
    try {
      const cart = await amdCartRequest('cart.js');
      amdRenderCart(drawer, cart);
      amdCartMessage(drawer, announcement);
    } catch (requestError) {
      amdCartMessage(drawer, requestError.message || drawer.dataset.errorLabel, true);
    } finally {
      amdCartBusy(drawer, false);
    }
    return true;
  };

  const amdCloseCart = () => {
    const drawer = amdCartDrawer();
    if (drawer?.open) drawer.close();
  };

  const amdChangeCart = async (control, quantity) => {
    const drawer = control.closest('[data-amd-cart-drawer]');
    if (!drawer) return;
    amdCartMessage(drawer, drawer.dataset.loadingLabel);
    amdCartBusy(drawer, true);
    try {
      const cart = await amdCartRequest('cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: control.dataset.lineKey, quantity })
      });
      amdRenderCart(drawer, cart);
      amdCartMessage(drawer, '');
      const nextFocus = drawer.querySelector(`[data-line-key="${CSS.escape(control.dataset.lineKey)}"]`) || drawer.querySelector('[data-amd-cart-action]') || drawer.querySelector('[data-amd-cart-close]');
      nextFocus?.focus();
    } catch (requestError) {
      if (control.matches('[data-amd-cart-action="quantity"]')) control.value = control.defaultValue;
      amdCartMessage(drawer, requestError.message || drawer.dataset.errorLabel, true);
    } finally {
      amdCartBusy(drawer, false);
    }
  };

  const amdAddToCart = async (form, submitter) => {
    const section = form.closest('[data-amd-product-section]');
    const drawer = amdCartDrawer();
    if (!drawer) return;
    if (section) amdSetPurchaseBusy(section, true);
    else if (submitter) submitter.disabled = true;
    amdCartRestoreFocus = submitter || form.querySelector('[name="add"]') || form;
    if (!drawer.open) drawer.showModal();
    document.body.classList.add('amd-cart-open');
    drawer.querySelector('[data-amd-cart-close]')?.focus();
    amdCartMessage(drawer, drawer.dataset.loadingLabel);
    amdCartBusy(drawer, true);
    try {
      const added = await amdCartRequest('cart/add.js', { method: 'POST', body: new FormData(form) });
      const cart = await amdCartRequest('cart.js');
      amdRenderCart(drawer, cart);
      amdCartMessage(drawer, `${drawer.dataset.addedLabel} · ${added.product_title || added.title || ''}`);
    } catch (requestError) {
      amdCartMessage(drawer, requestError.message || drawer.dataset.errorLabel, true);
    } finally {
      amdCartBusy(drawer, false);
      if (section?.isConnected) amdSetPurchaseBusy(section, false);
      else if (submitter?.isConnected) submitter.disabled = false;
      if (!drawer.open) amdRestoreCartFocus();
    }
  };

  const amdBindCart = (root = document) => {
    amdWithin(root, '[data-amd-cart-drawer]:not([data-amd-cart-ready])').forEach((drawer) => {
      drawer.dataset.amdCartReady = 'true';
      drawer.addEventListener('cancel', (event) => {
        event.preventDefault();
        amdCloseCart();
      });
      drawer.addEventListener('close', () => {
        document.body.classList.remove('amd-cart-open');
        amdRestoreCartFocus();
      });
      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) amdCloseCart();
      });
    });
  };

  const amdMenu = (button) => document.getElementById(button.getAttribute('aria-controls'));
  let amdMenuTimer;
  const amdSetMenu = (button, open, restoreFocus = false) => {
    const menu = amdMenu(button);
    if (!menu) return;
    window.clearTimeout(amdMenuTimer);
    button.setAttribute('aria-expanded', String(open));
    const label = button.querySelector('[data-amd-menu-label]');
    const nextLabel = open ? menu.dataset.amdCloseLabel : menu.dataset.amdOpenLabel;
    if (label && nextLabel) label.textContent = nextLabel;
    if (open) {
      menu.hidden = false;
      menu.inert = false;
      menu.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(() => {
        document.body.classList.add('amd-menu-open');
        menu.querySelector('a')?.focus();
      });
      return;
    }
    document.body.classList.remove('amd-menu-open');
    menu.inert = true;
    menu.setAttribute('aria-hidden', 'true');
    amdMenuTimer = window.setTimeout(() => {
      if (button.getAttribute('aria-expanded') === 'false') menu.hidden = true;
    }, amdMotionPreference.matches ? 0 : 360);
    if (restoreFocus) button.focus();
  };

  const amdBoot = (root = document) => {
    amdObserveCutouts(root);
    amdBindTilts(root);
    amdBindFilms(root);
    amdPrimeProducts(root);
    amdBindCart(root);
  };

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('[data-amd-cart-checkout]');
    if (checkout?.closest('[data-amd-cart-drawer]')?.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    const cartToggle = event.target.closest('[data-amd-cart-toggle]');
    const drawer = amdCartDrawer();
    if (cartToggle && drawer && typeof drawer.showModal === 'function') {
      event.preventDefault();
      amdOpenCart(cartToggle);
      return;
    }
    const cartClose = event.target.closest('[data-amd-cart-close]');
    if (cartClose) {
      amdCloseCart();
      return;
    }
    const remove = event.target.closest('[data-amd-cart-action="remove"]');
    if (remove) {
      amdChangeCart(remove, 0);
      return;
    }
    const menuButton = event.target.closest('[data-amd-menu-toggle]');
    if (menuButton) {
      amdSetMenu(menuButton, menuButton.getAttribute('aria-expanded') !== 'true');
      return;
    }
    const galleryButton = event.target.closest('[data-amd-gallery-target]');
    if (galleryButton) {
      const gallery = galleryButton.closest('[data-amd-gallery]');
      if (!gallery) return;
      const target = galleryButton.dataset.amdGalleryTarget;
      const panels = Array.from(gallery.querySelectorAll('[data-amd-gallery-panel]'));
      const activePanel = panels.find((panel) => panel.id === target);
      panels.forEach((panel) => panel.toggleAttribute('hidden', panel !== activePanel));
      gallery.querySelectorAll('[data-amd-gallery-target]').forEach((button) => button.setAttribute('aria-current', String(button === galleryButton)));
      gallery.querySelectorAll('[data-amd-gallery-panel]').forEach((panel) => {
        panel.querySelectorAll('video').forEach((video) => {
          if (panel.hidden) video.pause();
          else if (amdAllowsMotion()) video.play().catch(() => {});
        });
        if (panel.hidden) {
          panel.querySelectorAll('iframe').forEach((frame) => {
            const source = frame.src;
            if (!source) return;
            frame.removeAttribute('src');
            frame.src = source;
          });
          panel.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
        }
      });
      amdActivateCutouts(activePanel);
      amdBoot(gallery);
    }
  });

  document.addEventListener('change', async (event) => {
    const cartQuantity = event.target.closest('[data-amd-cart-action="quantity"]');
    if (cartQuantity) {
      const value = cartQuantity.value.trim();
      const parsedQuantity = Number(value);
      if (!value || !Number.isFinite(parsedQuantity) || parsedQuantity < 0) {
        cartQuantity.value = cartQuantity.defaultValue;
        return;
      }
      const quantity = Math.floor(parsedQuantity);
      await amdChangeCart(cartQuantity, quantity);
      return;
    }
    const option = event.target.closest('[data-amd-option-value]');
    if (!option) return;
    const section = option.closest('[data-amd-product-section]');
    const selectors = option.closest('[data-amd-option-selectors]');
    if (!section || !selectors) return;
    const previousValues = section.dataset.amdSelection || '';
    const values = amdSelectedOptionValues(section);
    if (values === previousValues) return;
    const focusId = option.id;
    const error = section.querySelector('[data-amd-variant-error]');
    if (error) error.hidden = true;
    amdSetPurchaseBusy(section, true);
    const nextProductUrl = option.dataset.productUrl || section.dataset.productUrl || window.location.pathname;
    const url = new URL(nextProductUrl, window.location.origin);
    url.searchParams.set('section_id', section.dataset.sectionId);
    url.searchParams.set('option_values', values);
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Variant request failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = html.querySelector(`[data-amd-product-section][data-section-id="${section.dataset.sectionId}"]`);
      if (!replacement) throw new Error('Variant response was incomplete');
      section.replaceWith(replacement);
      const browserUrl = new URL(replacement.dataset.productUrl || nextProductUrl, window.location.origin);
      browserUrl.searchParams.set('variant', replacement.dataset.variantId);
      window.history.replaceState({}, '', browserUrl);
      amdBoot(replacement);
      const variantMediaButton = replacement.dataset.variantMediaTarget
        ? replacement.querySelector(`[data-amd-gallery-target="${replacement.dataset.variantMediaTarget}"]`)
        : null;
      variantMediaButton?.click();
      window.Shopify?.PaymentButton?.init?.();
      window.requestAnimationFrame(() => {
        const focused = document.getElementById(focusId) || replacement.querySelector('[data-amd-option-value]:checked');
        focused?.focus();
      });
    } catch (requestError) {
      const previous = new Set(previousValues.split(',').filter(Boolean));
      selectors.querySelectorAll('[data-amd-option-value]').forEach((input) => {
        input.checked = previous.has(input.dataset.optionValueId);
      });
      if (error) error.hidden = false;
      window.requestAnimationFrame(() => document.getElementById(focusId)?.focus());
    } finally {
      if (section.isConnected) amdSetPurchaseBusy(section, false);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-amd-product-form]');
    if (!form) return;
    if (form.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    const addButton = form.querySelector('[name="add"]');
    if (event.submitter ? event.submitter !== addButton : document.activeElement !== addButton) return;
    const drawer = amdCartDrawer();
    if (!drawer || typeof drawer.showModal !== 'function') return;
    event.preventDefault();
    amdAddToCart(form, event.submitter);
  });

  document.addEventListener('keydown', (event) => {
    const button = document.querySelector('[data-amd-menu-toggle][aria-expanded="true"]');
    if (!button) return;
    const menu = amdMenu(button);
    if (!menu) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      amdSetMenu(button, false, true);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(menu.querySelectorAll('a[href], button:not([disabled])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  amdMotionPreference.addEventListener('change', () => {
    if (amdMotionPreference.matches) {
      document.querySelectorAll('[data-amd-card-film]').forEach((film) => amdStopCardFilm(film));
      document.querySelectorAll('[data-amd-product-film]').forEach((film) => film.pause());
    }
  });

  document.addEventListener('DOMContentLoaded', () => amdBoot());
  document.addEventListener('shopify:section:load', (event) => amdBoot(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amd-social-runway"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-amd-social-runway]';
    const states = new Map();
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const allowsAutomaticMotion = () => !motionPreference.matches && !connection?.saveData;
    const rootsWithin = (root) => {
      const roots = Array.from(root.querySelectorAll(rootSelector));
      if (root instanceof Element && root.matches(rootSelector)) roots.unshift(root);
      return roots;
    };
    const hydrateFilm = (film) => {
      if (film.dataset.amdHydrated === 'true') return;
      const source = film.querySelector('[data-amd-runway-src]');
      if (!source?.dataset.amdRunwaySrc) return;
      source.src = source.dataset.amdRunwaySrc;
      film.dataset.amdHydrated = 'true';
      film.load();
    };
    const waitForFilm = (film) => {
      if (film.readyState >= 2) return Promise.resolve();
      return new Promise((resolve, reject) => {
        const cleanup = () => {
          film.removeEventListener('loadeddata', ready);
          film.removeEventListener('canplay', ready);
          film.removeEventListener('error', failed);
        };
        const ready = () => {
          cleanup();
          resolve();
        };
        const failed = () => {
          cleanup();
          reject(new Error('media'));
        };
        film.addEventListener('loadeddata', ready);
        film.addEventListener('canplay', ready);
        film.addEventListener('error', failed);
      });
    };
    const updateCard = (card) => {
      const film = card.querySelector('[data-amd-runway-film]');
      const button = card.querySelector('[data-amd-runway-film-toggle]');
      if (!film || !button) return;
      const playing = !film.paused && !film.ended;
      card.classList.toggle('is-film-playing', playing);
      button.setAttribute('aria-pressed', String(playing));
      const label = button.querySelector('[data-amd-runway-film-label]');
      if (label) label.textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
      const icon = button.querySelector('.amd-runway-card__film-icon');
      if (icon) icon.textContent = playing ? 'Ⅱ' : '▶';
    };
    const playCard = async (card, automatic = false) => {
      if (automatic && !allowsAutomaticMotion()) return;
      const film = card.querySelector('[data-amd-runway-film]');
      if (!film || film.dataset.amdFailed === 'true') return;
      states.forEach((state) => state.cards.forEach((otherCard) => {
        if (otherCard !== card) stopCard(otherCard, false);
      }));
      film.dataset.amdPlayRequested = 'true';
      hydrateFilm(film);
      try {
        await waitForFilm(film);
        if (film.dataset.amdPlayRequested !== 'true') return;
        await film.play();
      } catch (error) {}
      updateCard(card);
    };
    const stopCard = (card, reset = true) => {
      const film = card.querySelector('[data-amd-runway-film]');
      if (!film) return;
      film.dataset.amdPlayRequested = 'false';
      film.pause();
      if (reset) {
        try { film.currentTime = 0; } catch (error) {}
      }
      updateCard(card);
    };
    const initialize = (root) => {
      if (states.has(root)) return;
      const rail = root.querySelector('[data-amd-runway-rail]');
      const cards = Array.from(root.querySelectorAll('[data-amd-runway-card]'));
      const state = { cards, observer: null };
      states.set(root, state);
      root.querySelector('[data-amd-runway-previous]')?.addEventListener('click', () => rail?.scrollBy({ left: -(rail.clientWidth * .84), behavior: motionPreference.matches ? 'auto' : 'smooth' }));
      root.querySelector('[data-amd-runway-next]')?.addEventListener('click', () => rail?.scrollBy({ left: rail.clientWidth * .84, behavior: motionPreference.matches ? 'auto' : 'smooth' }));
      cards.forEach((card) => {
        const film = card.querySelector('[data-amd-runway-film]');
        const button = card.querySelector('[data-amd-runway-film-toggle]');
        card.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') playCard(card, true);
        });
        card.addEventListener('pointerleave', () => {
          if (!card.matches(':focus-within')) stopCard(card);
        });
        card.addEventListener('focusin', () => playCard(card, true));
        card.addEventListener('focusout', () => queueMicrotask(() => {
          if (!card.contains(document.activeElement)) stopCard(card);
        }));
        button?.addEventListener('click', () => {
          if (!film) return;
          if (film.paused) playCard(card);
          else stopCard(card);
        });
        film?.addEventListener('playing', () => updateCard(card));
        film?.addEventListener('pause', () => updateCard(card));
        film?.addEventListener('ended', () => updateCard(card));
        film?.addEventListener('error', () => {
          film.dataset.amdFailed = 'true';
          if (button) button.disabled = true;
          stopCard(card);
        });
        updateCard(card);
      });
      if ('IntersectionObserver' in window) {
        state.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) stopCard(entry.target);
          });
        }, { threshold: .08 });
        cards.forEach((card) => state.observer.observe(card));
      }
    };
    const destroy = (root) => {
      const state = states.get(root);
      if (!state) return;
      state.observer?.disconnect();
      state.cards.forEach((card) => stopCard(card));
      states.delete(root);
    };
    const boot = (root) => rootsWithin(root).forEach(initialize);
    const stopAutomaticFilms = () => {
      if (allowsAutomaticMotion()) return;
      states.forEach((state) => state.cards.forEach((card) => stopCard(card)));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
    document.addEventListener('shopify:section:unload', (event) => rootsWithin(event.target).forEach(destroy));
    motionPreference.addEventListener('change', stopAutomaticFilms);
    connection?.addEventListener?.('change', stopAutomaticFilms);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-amd-collection-sort]')) return;
    const existingNames = new Set(Array.from(form.elements, (element) => element.name));
    new URLSearchParams(window.location.search).forEach((value, name) => {
      if (name === 'sort_by' || name === 'page' || existingNames.has(name)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.append(input);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
